import { ReactComponent as CarSvg } from '../../assets/icons/car.svg';

export const CarIcon: SvgIcon = (props) => {
    return <CarSvg {...props} />;
};
